(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/statistics/assets/javascripts/statistics.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/statistics/assets/javascripts/statistics.js');
"use strict";


const classHidden = 'sportsbook-statistics-is-hidden';
const classIframe = 'js-sportsbook-statistics-frame';
const classCloseBtn = 'js-sportsbook-statistics-close';
function init() {
  const containerEl = document.createElement('div');
  containerEl.innerHTML = svs.sportsbook.templates.statistics();
  const statisticsEl = containerEl.firstChild;
  const iframe = statisticsEl.querySelector(".".concat(classIframe));
  const closeBtn = statisticsEl.querySelector(".".concat(classCloseBtn));
  statisticsEl.classList.add(classHidden);
  document.body.appendChild(statisticsEl);
  function show(statisticsUrl) {
    iframe.src = statisticsUrl;
    statisticsEl.classList.remove(classHidden);
    document.body.style.overflow = 'hidden';
  }
  function hide() {
    statisticsEl.classList.add(classHidden);
    iframe.src = '';
    document.body.style.overflow = 'visible';
  }
  closeBtn.addEventListener('click', hide);
  statisticsEl.addEventListener('click', hide);
  return {
    show,
    hide
  };
}
svs.sportsbook.statistics.init = init;

 })(window);